import { ControlType, FormField, FormFieldInit } from "./base";

export class FormFieldRange extends FormField {
  override controlType = ControlType.RANGE;
  public override initialValue?: number | undefined;

  min?: number;
  max?: number;
  step?: number;

  color?: RangeColor;
  computedSublabel?: ComputedSublabel | undefined;

  constructor(init: FormFieldInit<FormFieldRange>) {
    super(init);
    this.initialValue = init.initialValue || 300000;
    this.min = init.min || 0;
    this.max = init.max || 600000;
    this.step = init.step || 10000;
    this.color = init.color || "primary";
    this.computedSublabel = init.computedSublabel;
  }
}

export type RangeColor = "primary" | "black";

export type ComputedSublabel = {
  prefix?: string;
  calculation: (value: number) => number;
  suffix?: string;
};
